import { render, staticRenderFns } from "./hs-code.vue?vue&type=template&id=74088f76&scoped=true&"
import script from "./hs-code.vue?vue&type=script&lang=js&"
export * from "./hs-code.vue?vue&type=script&lang=js&"
import style0 from "./hs-code.vue?vue&type=style&index=0&id=74088f76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74088f76",
  null
  
)

export default component.exports